<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'+'机位'"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :visible.sync="visible"
    width="720px"
    height="456px"
    class="info-dialog"
  >
    <el-form
      ref="dataForm"
      label-position="right"
      label-width="120px"
      :model="dataForm"
      :rules="rules"
    >
      <el-form-item prop="roomId" label="场地名称：">
        <el-select v-model="dataForm.roomId" placeholder="请选择场地名称" @change="filedSelectHandle">
          <el-option
            v-for="item in getBidList"
            :key="item.id"
            :label="item.filedName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="seatName" label="机位名称：">
        <el-input
          v-model.trim="dataForm.seatName"
          placeholder="请输入机位名称"
          maxlength="30"
          clearable
        />
      </el-form-item>
      <el-form-item prop="seatCode" label="机位编码：">
        <el-input
          v-model.trim="dataForm.seatCode"
          placeholder="请输入机位编码"
          clearable
          maxlength="30"
        />
      </el-form-item>
      <el-form-item prop="seatMac" label="机位物理地址：">
        <el-input
          v-model.trim="dataForm.seatMac"
          placeholder="请输入机位编码"
          clearable
          maxlength="36"
        />
      </el-form-item>
      <!--  0启用 1停用 -->
      <el-form-item prop="seatStatus" label="是否启用：">
        <el-switch
          v-model="dataForm.seatStatus"
          :active-value="0"
          :inactive-value="1"
          active-color="#1890FF"
          inactive-color="#F23030"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-preventReClick type="primary" @click="dataFormSubmit()">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      getBidList: [],
      dataForm: {
        id: '',
        tradeOrgId: '',
        filedName: '',
        roomId: '',
        seatName: '',
        seatCode: '',
        seatMac: '',
        seatStatus: 0
      },
      rules: {
        roomId: [
          { required: true, message: '请选择场地名称', trigger: 'blur' }
        ],
        seatName: [
          { required: true, message: '请填写机位名称', trigger: 'blur' }
        ],
        seatCode: [
          { required: true, message: '请填写机位编码', trigger: 'blur' }
        ],
        seatMac: [
          { required: true, message: '请填写机位物理地址', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleClose() {
      this.visible = false
    },
    filedSelectHandle(val) {
      const index = this.getBidList.findIndex(mitem => mitem.id === val)
      if (index > -1) {
        this.dataForm.filedName = this.getBidList[index].filedName
      } else {
        this.dataForm.filedName = ''
      }
    },
    getBid(tradeOrgId) {
      this.$http.get(`/configs/sysevalroom/getEvalRoomOptions?tradeOrgId=${tradeOrgId}`).then(res => {
        if (res.data.code === '1') {
          this.getBidList = res.data.data || []
        }
      })
    },
    init(id, tradeOrgId) {
      this.visible = true
      this.dataForm.id = id || ''
      this.dataForm.tradeOrgId = tradeOrgId
      this.$nextTick(() => {
        this.getBid(tradeOrgId)
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http.get(`/configs/sysevalroomseats/get?id=${id}`).then(res => {
            if (res.data.code === '1') {
              this.dataForm = res.data.data ? res.data.data : {}
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http.post(`/configs/sysevalroomseats/save`, this.dataForm).then(res => {
            if (res.data.code === '1') {
              this.$message.success(res.data.msg)
              this.visible = false
              this.$emit('refreshDataList')
            } else {
              this.$message.error(res.data.msg)
              this.visible = false
            }
          })
        }
      })
    }
  }
}
</script>
